
<div id="toolbar" class="shadow-md p-1 absolute w-full">
  <div class="flex justify-center">
    <a href="/" ><img src="/assets/img/logo-white.svg" alt="DoktorDoktor Logo" class="w-64" /></a>
  </div>
</div>

<router-outlet></router-outlet>

<div id="footer" class="bg-footer-gray w-full py-10 flex">
  <span class="flex-auto"></span>
  <a class="uppercase text-gray-300 px-5"  href="/impressum">
    Impressum
  </a>
  <a class="uppercase text-gray-300 px-5" target="_blank" href="/assets/doktordoktor-agb.pdf">
    AGBs
  </a>
  <a class="uppercase text-gray-300 px-5" target="_blank" href="/assets/doktordoktor-datenschutz.pdf">
    Datenschutz
  </a>
</div>